// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2Grja","unreadBadge":"styles_unreadBadge__2PuI7","modalContent":"styles_modalContent__2dfHy","modal":"styles_modal__2BKs6"};